export default "__VITE_ASSET__668ace56__"